// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3rDJU","loadingShrink":"PageLoading_loadingShrink__11Fzo"};